import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveAgenteSaqueFailure, saveAgenteSaqueSuccess, updateAgenteSaqueFailure, updateAgenteSaqueSuccess } from './actions';

export function* saveAgenteSaque({ payload }) {
  try {
    const response = yield call(api.post, 'api/agentes-saque', payload.data, { withCredentials: true });

    yield put(saveAgenteSaqueSuccess());

    toast.success('Agente de Saque criado com sucesso!')

    const id = response.headers.location;

    history.push(`/specifications/agentes-saque`);
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveAgenteSaqueFailure());
  }
}

export function* updateAgenteSaque({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/agentes-saque/${id}`, payload.data, { withCredentials: true });

    yield put(updateAgenteSaqueSuccess());

    toast.success('Agente de Saque atualizada com sucesso!')

    history.push('/specifications/agentes-saque');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateAgenteSaqueFailure());
  }
}

export default all([
  takeLatest('@agenteSaque/SAVE_REQUEST', saveAgenteSaque),
  takeLatest('@agenteSaque/UPDATE_REQUEST', updateAgenteSaque)
]);